<template>
    <div class="container">
        <single-menu-item 
            v-if="!menuItem.ChildItems || menuItem.ChildItems.length === 0"
            :menu-item="menuItem" />
        <multiple-menu-item 
            v-else
            :menu-item="menuItem" />
    </div>
</template>

<script>
import multipleMenuItem from './multipleMenuItem.vue';
import singleMenuItem from './singleMenuItem.vue';

export default {
    name: 'menu-item-details',
    components: {
        'multiple-menu-item': multipleMenuItem,
        'single-menu-item': singleMenuItem
    },
    props: {
        menuItem: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
</style>